// Traductions de l'outil : window.PTX_T (texte français → traduction), écrit par le thème hors français.
var ptxT = window.ptxT || (window.ptxT = (s) => (window.PTX_T && window.PTX_T[s]) || s);
/* Printtex (images IA posées à 20 cm) : « Créer avec l'IA » dans les onglets Image et Idées de l'outil de personnalisation.
   Le client décrit son image, reçoit 2 propositions (Worker Cloudflare « printtex-creation-ia », aucune clé ici),
   en choisit une : elle est remise à l'outil exactement comme une image importée (fond blanc retiré par l'outil).
   Fichier séparé de printtex-perso.js : s'appuie seulement sur [data-pp-panel="image"], .pp-drop, [data-pp-file]
   et [data-pp-panel="idees"] (créé par printtex-modeles.js, s'il existe).
   Adresse du Worker : attribut data-api de la balise <script> (layout/theme.liquid). Vide = bouton caché,
   sauf avec ?ia=demo dans l'adresse (images de démonstration, sans appel réseau, pour tester l'interface). */
(() => {
  const script = document.currentScript;
  const API = (script?.dataset.api || '').replace(/\/$/, '');
  const DEMO = /[?&]ia=demo\b/.test(location.search);
  if (!API && !DEMO) return;
  const COTE = 2048; // l'image IA (1024 px) est agrandie ×2 : ≈ 150 dpi sur 35 cm de large, 300 dpi sur 17 cm

  const ICONE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3l1.8 4.7L18.5 9.5l-4.7 1.8L12 16l-1.8-4.7L5.5 9.5l4.7-1.8z"/><path d="M19 15l.8 2.2L22 18l-2.2.8L19 21l-.8-2.2L16 18l2.2-.8z"/></svg>';

  const PANNEAUX = {
    image: ptxT("Pas d'image ? Décrivez-la, on vous en propose 2."),
    idees: ptxT("Aucun modèle ne convient ? Décrivez votre image, on vous en propose 2."),
  };

  function installerDans(nom) {
    const panneau = document.querySelector(`[data-pp-panel="${nom}"]`);
    const fichier = document.querySelector('[data-pp-file]');
    if (!panneau || !fichier) return false;
    if (panneau.querySelector('.pp-ia')) return true;

    const bloc = document.createElement('div');
    bloc.className = 'pp-ia';
    bloc.innerHTML = `
      <button type="button" class="pp-ia__ouvrir" aria-expanded="false">${ICONE}
        <span><strong>${ptxT("Créer avec l'IA")}</strong><br>${PANNEAUX[nom]}</span></button>
      <div class="pp-ia__boite" hidden>
        <label class="pp-label" for="pp-ia-texte-${nom}">${ptxT("Décrivez votre image")}</label>
        <textarea id="pp-ia-texte-${nom}" class="pp-input" maxlength="300" rows="2" placeholder="${ptxT("Ex. : un lion qui joue de la guitare, style rétro")}"></textarea>
        <button type="button" class="pp-btn pp-ia__creer">${ptxT("Créer 2 propositions")}</button>
        <p class="pp-note pp-ia__info">${ptxT("Pas de marques, personnages existants, personnes célèbres ni style d'un artiste. 5 créations par jour.")}</p>
        <p class="pp-ia__erreur" role="alert"></p>
        <div class="pp-ia__choix" aria-live="polite"></div>
      </div>`;
    const drop = nom === 'image' && panneau.querySelector('.pp-drop');
    if (drop) drop.after(bloc); else panneau.prepend(bloc);

    const ouvrir = bloc.querySelector('.pp-ia__ouvrir');
    const boite = bloc.querySelector('.pp-ia__boite');
    const texte = bloc.querySelector('textarea');
    const creer = bloc.querySelector('.pp-ia__creer');
    const info = bloc.querySelector('.pp-ia__info');
    const erreur = bloc.querySelector('.pp-ia__erreur');
    const choix = bloc.querySelector('.pp-ia__choix');

    ouvrir.addEventListener('click', () => {
      const ouvert = boite.hidden;
      boite.hidden = !ouvert;
      ouvrir.setAttribute('aria-expanded', String(ouvert));
      if (ouvert) texte.focus();
    });
    texte.addEventListener('keydown', (e) => { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); creer.click(); } });

    creer.addEventListener('click', async () => {
      const description = texte.value.trim();
      erreur.textContent = '';
      if (description.length < 3) { erreur.textContent = ptxT("Décrivez votre image en quelques mots."); return; }
      creer.disabled = true;
      creer.textContent = ptxT("Création en cours…");
      choix.innerHTML = '<div class="pp-ia__attente"></div><div class="pp-ia__attente"></div>';
      try {
        const r = DEMO ? await demo(description) : await fetch(`${API}/creer`, {
          method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ description, nombre: 2 }),
        }).then(async (res) => ({ ok: res.ok, ...(await res.json().catch(() => ({ erreur: ptxT("La création n'a pas abouti. Réessayez dans un instant.") }))) }));
        if (!r.ok || !r.images?.length) throw new Error(r.erreur || ptxT("La création n'a pas abouti. Réessayez dans un instant."));
        choix.innerHTML = '';
        r.images.forEach((src, i) => {
          const b = document.createElement('button');
          b.type = 'button';
          b.className = 'pp-ia__image';
          b.innerHTML = `<img src="${src}" alt="Proposition ${i + 1} : ${description.replace(/[<>"&]/g, '')}"><span>${ptxT("Choisir")}</span>`;
          b.addEventListener('click', () => utiliser(src, b));
          choix.append(b);
        });
        if (typeof r.restant === 'number') info.textContent = `${ptxT("Choisissez une proposition. Il vous reste")} ${r.restant} ${ptxT("création")}${r.restant > 1 ? 's' : ''} aujourd'hui.`;
        if (r.avertissement) info.textContent += ` ${r.avertissement}`; // logo de marque détourné : rappel des droits (règle de Karim, 17/10)
        try { window.Shopify?.analytics?.publish?.('perso_ia', { page: location.pathname }); } catch (e) { /* mesure seulement */ }
      } catch (e) {
        choix.innerHTML = '';
        erreur.textContent = e.message;
      } finally {
        creer.disabled = false;
        creer.textContent = ptxT("Créer 2 propositions");
      }
    });

    /* Agrandit l'image choisie en PNG 2048 px et la passe à l'outil comme un fichier importé. */
    async function utiliser(src, bouton) {
      bouton.disabled = true;
      try {
        const img = new Image();
        img.src = src;
        await img.decode();
        const c = document.createElement('canvas');
        c.width = COTE; c.height = Math.round(COTE * img.naturalHeight / img.naturalWidth);
        const ctx = c.getContext('2d');
        ctx.imageSmoothingEnabled = true;
        ctx.imageSmoothingQuality = 'high';
        ctx.drawImage(img, 0, 0, c.width, c.height);
        const blob = await new Promise((ok) => c.toBlob(ok, 'image/png'));
        const P = window.PrinttexPerso;
        const avant = [...(P?.canvas()?.getObjects() || [])]; // copie : getObjects() renvoie le tableau vivant
        const dt = new DataTransfer();
        dt.items.add(new File([blob], `creation-ia-${Date.now()}.png`, { type: 'image/png' }));
        fichier.files = dt.files;
        fichier.dispatchEvent(new Event('change', { bubbles: true }));
        if (P) taille20(P, avant);
        boite.hidden = true;
        ouvrir.setAttribute('aria-expanded', 'false');
      } catch (e) {
        erreur.textContent = ptxT("Impossible d'utiliser cette image. Essayez l'autre proposition.");
      } finally {
        bouton.disabled = false;
      }
    }
    return true;
  }

  /* Image IA posée à 20 cm de large (moins si la zone est plus petite) : à cette taille elle est nette (≈ 260 dpi),
     donc pas d'alerte « image un peu juste » dès le choix. Le client peut ensuite l'agrandir. */
  const LARGEUR_CM = 20;
  // Attend l'image ajoutée par l'outil (chargement et retrait du fond asynchrones), puis la réduit une fois que l'outil a
  // fini de la placer (il réajuste son échelle juste après l'ajout), et relance l'alerte de résolution et le prix.
  function taille20(P, avant) {
    const c = P.canvas();
    let fini = false;
    const reduire = (o) => {
      const z = P.zoneOf(P.state.side);
      const cible = (Math.min(LARGEUR_CM, z.cmW) * P.LOGICAL_W) / z.cmW;
      if (!c.getObjects().includes(o) || o.getScaledWidth() <= cible) return;
      const centre = o.getCenterPoint();
      const k = cible / o.getScaledWidth(); // pas scaleToWidth : il compte le zoom d'affichage du canvas
      o.set({ scaleX: o.scaleX * k, scaleY: o.scaleY * k });
      o.setPositionByOrigin(centre, 'center', 'center');
      P.fitInZone(o);
      o.setCoords();
      c.setActiveObject(o);
      c.requestRenderAll();
      P.snapshot();
      P.onSelection();
      P.updatePrice();
    };
    const surAjout = (e) => {
      const o = e.target;
      if (fini || !o || o.type !== 'image' || avant.includes(o)) return;
      fini = true;
      c.off('object:added', surAjout);
      setTimeout(() => reduire(o), 300);
    };
    c.on('object:added', surAjout);
    setTimeout(() => { if (!fini) { fini = true; c.off('object:added', surAjout); } }, 30000);
  }

  /* Mode démonstration : 2 images dessinées sur place (fond blanc), sans appel au Worker. */
  async function demo(description) {
    await new Promise((ok) => setTimeout(ok, 900));
    const images = ['#b87a4b', '#2563eb'].map((couleur, i) => {
      const c = document.createElement('canvas');
      c.width = c.height = 1024;
      const x = c.getContext('2d');
      x.fillStyle = '#ffffff'; x.fillRect(0, 0, 1024, 1024);
      x.fillStyle = couleur;
      x.beginPath();
      if (i) x.arc(512, 440, 300, 0, Math.PI * 2); else { x.moveTo(512, 120); x.lineTo(860, 760); x.lineTo(164, 760); x.closePath(); }
      x.fill();
      x.fillStyle = '#171717'; x.font = 'bold 64px sans-serif'; x.textAlign = 'center';
      x.fillText(description.slice(0, 24), 512, 900);
      return c.toDataURL('image/jpeg', 0.9);
    });
    return { ok: true, images, restant: 4 };
  }

  // L'onglet Idées est ajouté plus tard par printtex-modeles.js : on surveille la page quelques secondes.
  const tout = () => Object.keys(PANNEAUX).map(installerDans).every(Boolean);
  if (!tout()) {
    const obs = new MutationObserver(() => { if (tout()) obs.disconnect(); });
    obs.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(() => obs.disconnect(), 30000);
  }
})();
